// extracted by mini-css-extract-plugin
export default {"menuItem":"eMFKmXs8","destructive":"C84vY_ER"};